import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../redux/auth/thunks";
import {useHistory} from "react-router-dom";

const Header = () => {
    const user = useSelector(state => state.auth.user);
    const history = useHistory();
    const dispatch = useDispatch();

    const onLogout = () => {
        dispatch(logout());

        history.replace('/');
    };

    return (
        <div className="text-right login-message">
            <p>
                Welcome <b>{user.first_name}</b>, <a href="#" onClick={onLogout}>logout</a>.
            </p>
        </div>
    );
};

export default Header;
